<template lang="pug">
  v-container(fluid)
    Search(:location="location" :title="title")
</template>

<script>
import locationService from '../service.js'
import Search from '../components/SearchList'
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      location: [],
      title: null
    }
  },
  components: {
    Search
  },
  computed: {
    ...mapGetters('global', ['search'])
  },
  watch: {
    search(val) {
      this.searchInStores(val)
    }
  },
  created() {
    // if (!this.$route.params || !this.$route.params.id) return this.$router.push("/location")
    this.searchInStores(this.search)
  },
  methods: {
    searchInStores(val) {
      // if (!this.$route.params) return this.$router.push("/location")
      this.title = this.search
      locationService.searchInStores({search: val})
      .then(result => {
        this.location = result.data
        console.log('resutld', result)
      })
    }
   
  }
}
</script>

<style scoped>
</style>